import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { useCheckoutStoreContext } from '../../context';
import DateTimePicker from 'src/view/components/Controls/Pickers/DateTimePicker/DateTimePicker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import TabPicker from 'src/view/components/Controls/Pickers/TabPicker/TabPicker';
import Text, { TEXT } from 'src/view/components/Text/Text';

const CheckoutDueTime: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  const dueTimeOptions = useMemo((): IPickerOption[] => {
    return [
      { value: 0, label: 'asap' },
      { value: 1, label: 'ahead' },
    ];
  }, []);

  return (
    <div className="d-flex align-items-center mb-3">
      <Text type={TEXT.ORDER_FIELD} text="due_time" />
      <div className="d-flex flex-row flex-wrap gap-15">
        {/* asap/ahead picker */}
        <TabPicker
          value={checkoutStore.params.preorder}
          options={dueTimeOptions}
          onChange={checkoutStore.changePreorder}
          error={checkoutStore.validatorErrors.preorder}
          disabled={!checkoutStore.dependencies.branch.id || !checkoutStore.dependencies.branch.preorder}
        />
        {/* date time picker */}
        {checkoutStore.dependencies.branch.id ? (
          <DateTimePicker
            disabled={checkoutStore.params.preorder === 0}
            error={checkoutStore.validatorErrors.preorder_date}
            onDateChange={checkoutStore.changePreorderDate}
            date={checkoutStore.params.preorder_date}
          />
        ) : null}
      </div>
    </div>
  );
});

export default CheckoutDueTime;
